import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2b1082fa")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1 pb-0" }, " Use this report to identify when your Gas meters were last billed using a customer or supplier reading. ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "card mb-2 mb-xl-3" }
const _hoisted_4 = { class: "card-body pt-2 pb-0" }
const _hoisted_5 = {
  class: "d-flex overflow-auto h-55px",
  style: {"float":"right"}
}
const _hoisted_6 = { id: "container" }
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = { class: "tab" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Graph(s) ", -1)
const _hoisted_10 = { class: "tab" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Table ", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  class: "card mb-5 mb-xl-5",
  id: "kt_profile_details_view"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  style: {"float":"right !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0 row col-md-5" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder m-0" }, "Last 'Actual' Meter Read Report - Gas")
  ])
], -1)
const _hoisted_15 = { id: "chart" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  style: {},
  id: "loadingDiv"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_19 = [
  _hoisted_18
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAssetGraph && _ctx.openAssetGraph(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_9
              ]),
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAssetRemoval && _ctx.openAssetRemoval(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_11
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.graph)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_apexchart, {
                ref: "chart",
                type: "bar",
                height: "350",
                options: _ctx.eboptions.chartOptions,
                series: _ctx.series
              }, null, 8, ["options", "series"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tablesumm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_TableTab, {
            "table-data": _ctx.tableDatanew,
            "table-header": _ctx.OriginalTableHeaders,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnames,
            pagetitle: _ctx.pageheader
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      : _createCommentVNode("", true)
  ], 64))
}